import { Action } from './Farm';
import { Bed, adaptBed } from './Bed';

export interface Plot {
  id: string;  // CN-0012: UUID-only
  storeId?: string;
  fieldId: string;  // CN-0012: UUID-only
  name: string;
  area?: number | null;
  location_coords?: string | null;
  description?: string | null;
  actions?: Action[];
  beds?: Bed[];
  field?: { id: string; farmId?: string; farm?: { id: string } };  // CN-0012: Backend returns nested field object
}

export const adaptPlot = (data: any): Plot => ({
  id: data.id,
  storeId: data.storeId ?? data.store_id ?? undefined,
  fieldId: data.fieldId ?? data.field_id ?? data.field?.id,  // CN-0012: Backend may return field as nested object
  name: data.name,
  area: data.area ?? null,
  location_coords: data.location_coords ?? null,
  description: data.description ?? null,
  actions: (data.actions || []).map((a: any) =>
    typeof a === 'string'
      ? { title: '', code: a }
      : { title: a.title, code: a.code, state: a.state },
  ),
  beds: (data.beds || data.rows || data.bed_list || []).map((b: any) => adaptBed(b)),
  field: data.field ? {
    id: data.field.id,
    farmId: data.field.farmId ?? data.field.farm_id ?? data.field.farm?.id,
    farm: data.field.farm
  } : undefined,
});

